import { Project } from 'api/generated/graphql';

const hasEnded = (project: Project) =>
  project.artworksCount && project.mintLimit
    ? project.mintLimit <= project.artworksCount
    : false;

export default hasEnded;
